import { useParams } from 'react-router-dom';
import { Grid, Box } from '@mui/material';
import { ProjectManagers } from './product-managers';
import { Supervisors } from './supervisors';
import { WarrantySupervisors } from './warranty-supervisors';
import { Foremen } from './foremen';

export const SupervisorPm = () => {
  const { neighborhoodId }: { neighborhoodId: string } = useParams();

  return (
    <Box mt={1}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <ProjectManagers neighborhoodId={neighborhoodId}></ProjectManagers>
        </Grid>
        <Grid item xs={12}>
          <Supervisors neighborhoodId={neighborhoodId}></Supervisors>
        </Grid>
        <Grid item xs={12}>
          <WarrantySupervisors neighborhoodId={neighborhoodId}></WarrantySupervisors>
        </Grid>
        <Grid item xs={12}>
          <Foremen neighborhoodId={neighborhoodId}></Foremen>
        </Grid>
      </Grid>
    </Box>
  );
};
